(function(){
	const initGallerySwiper = () => {
		const section = document.querySelector('.section-gallery');

		if (!section) {
			return;
		}

		const swiperEl = section.querySelector('.mySwiper');
		const paginationEl = section.querySelector('.custom-pagination');
		const prevEl = section.querySelector('.gallery-prev');
		const nextEl = section.querySelector('.gallery-next');

		if (!swiperEl) {
			return;
		}

		const swiper = new Swiper(swiperEl, {
			slidesPerView: 'auto',
			centeredSlides: true,
			spaceBetween: 30,
			loop: true,
			observer: true,
			observeParents: true,
			pagination: {
				el: paginationEl,
				clickable: true
			},
			navigation: {
				prevEl: prevEl,
				nextEl: nextEl
			},
			on: {
				init: function() {
					// Force update after a brief delay to recalculate slide dimensions
					setTimeout(() => {
						this.update();
					}, 200);
				}
			}
		});
	};

	const initVideoPlayers = () => {
		const videoSections = document.querySelectorAll('.image-section-video, .card__item-video');

		videoSections.forEach(section => {
			const playButton = section.querySelector('.video-play-button');
			const previewImage = section.querySelector('.video-preview-image');
			const videoContainer = section.querySelector('.video-container');
			const videoUrl = section.getAttribute('data-video-url');

			if (!playButton || !videoUrl) {
				return;
			}

			playButton.addEventListener('click', function() {
				// Extract YouTube video ID
				let videoId = '';
				const urlParams = new URLSearchParams(new URL(videoUrl).search);
				videoId = urlParams.get('v');

				// Handle youtu.be short URLs
				if (!videoId && videoUrl.includes('youtu.be/')) {
					videoId = videoUrl.split('youtu.be/')[1].split('?')[0];
				}

				if (!videoId) {
					console.error('Could not extract YouTube video ID from URL:', videoUrl);
					return;
				}

				// Create iframe
				const iframe = document.createElement('iframe');
				iframe.setAttribute('src', `https://www.youtube.com/embed/${videoId}?autoplay=1`);
				iframe.setAttribute('frameborder', '0');
				iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
				iframe.setAttribute('allowfullscreen', '');
				iframe.style.width = '100%';
				iframe.style.height = '100%';
				iframe.style.position = 'absolute';
				iframe.style.top = '0';
				iframe.style.left = '0';

				// Hide preview image and play button
				if (previewImage) {
					previewImage.style.display = 'none';
				}
				playButton.style.display = 'none';

				// Show and populate video container
				videoContainer.style.display = 'block';
				videoContainer.appendChild(iframe);
			});
		});
	};

	gsap.registerPlugin(ScrollTrigger, SplitText) ;
	gsap.config({nullTargetWarn:false});

	const revealFacts=()=>{
		const items=gsap.utils.toArray('.facts__item');

		if(items.length===0){
			return;
		}

		items.forEach(item=>{
			// Reveal up
			gsap.from(item, {
				y:50,
				autoAlpha:0,
				duration:2,
				ease:'power4.out',
				scrollTrigger:{
					trigger:item,
					start:'top 80%'
				}
			});

			// Count up
			let numberEl=item.querySelector('.facts__item-number');
			const unitEl=item.querySelector('.facts__item-unit');

			// Fallback to h3 for backwards compatibility
			if(!numberEl){
				numberEl=item.querySelector('h3');
			}

			if(!numberEl){

				return;
			}

			// Extract unit from the unit element
			const unit=unitEl?unitEl.getAttribute('data-unit'):'';

			const endValue=parseFloat(numberEl.textContent.replace(/\./g,'').replace(',','.'));

			if(isNaN(endValue)){

				return;
			}

			gsap.fromTo(numberEl, {innerText:0}, {
				innerText:endValue,
				duration:2,
				ease:'power1.out',
				snap:{innerText:1},
				scrollTrigger:{
					trigger:item,
					start:'top 80%'
				},
				onUpdate:function(){
					numberEl.textContent=Math.floor(this.targets()[0].innerText).toLocaleString('de-DE');
				}
			});

			// Make sure unit is visible
			if(unitEl){
				gsap.set(unitEl, {autoAlpha:1});
			}
		});
	};

	const initSplit=(selectors, type='words')=>{
		if(!Array.isArray(selectors)){
			selectors=[selectors];
		}

		selectors.forEach(selector=>{
			const elements=gsap.utils.toArray(selector);

			if(elements.length===0){

				return;
			}

			elements.forEach(el=>{
				new SplitText(el, {type:type, linesClass:'split-child'});

				gsap.set(el, {opacity:1});

				gsap.from(el.querySelectorAll('div'), {
					y:24,
					autoAlpha:0,
					ease:'power4.out',
					stagger:0.1,
					duration:2,
					scrollTrigger:{
						trigger:el,
						start:'top 80%',
						end:'bottom center'
					}
				});
			});
		});

		if(typeof ScrollTrigger!=='undefined'){
			ScrollTrigger.refresh();
		}
	};

	const revealFromBottom=(selectors, offset=50)=>{
		if(!Array.isArray(selectors)){
			selectors=[selectors];
		}

		selectors.forEach(selector=>{
			const elements=gsap.utils.toArray(selector);

			if(elements.length===0){

				return;
			}

			elements.forEach(el=>{
				gsap.set(el, {opacity:1});

				gsap.from(el, {
					y:offset,
					autoAlpha:0,
					duration:2,
					ease:'power4.out',
					scrollTrigger:{
						trigger:el,
						start:'top 80%'
					}
				});
			});
		});

		if(typeof ScrollTrigger!=='undefined'){
			ScrollTrigger.refresh();
		}
	};

	document.addEventListener('DOMContentLoaded',()=>{
		setTimeout(() => {
			initGallerySwiper();
			initVideoPlayers();
		}, 800);

		setTimeout(()=>{
			revealFromBottom([
				'.breadcrumb',
				'.hero-media-slot',
				'.hero .hero-image-wrap',
				'.hero .wp-block-buttons',
				'.hero .mb-auto > svg',
				'section.text-image .w-20 > img',
				'section.text-image .rounding-lg.bg-brand-50',
				'.cards__items > div',
				'section.logo-section .logo-section-item',
				'section.logo-section .logo-section-item-block',
				'.call-to-action__content .wp-block-buttons',
				'.timeline__items .timeline__item',
				'section.image-section .image-section-text-wrap > .wp-block-buttons',
				'section.image-section .image-section-image-wrap',
				'.downloads__item',
				'.faq__item',
				'.section-gallery',
				'.is-style-lead',
				'.fancy-text-image-with-card-items > div',
				'.compare__items .compare__item-text .compare__item-image',
			]);
			// revealFromBottom(['.section-title'], 80);

			initSplit([
				'.hero p',
				'section.text-image p',
				'.call-to-action__content p',
				'section.image-section .image-section-text-wrap > p',
				'.fancy-text-image-with-card-item__text',
				'.compare__items .compare__item-text > div:last-child',
			], 'lines');

			initSplit([
				'.hero h1',
				'section.text-image .wp-block-palllm-text-image-item h2',
				'.fancy-text-image-with-card-item__text-wrap h2',
				'h1.section-head',
				'h2.section-head',
				'section.logo-section h3',
				'.call-to-action__content h2',
				'section.image-section .section-head-wrapper > p.is-style-lead',
				'.downloads__items > h2',
				'.fancy-text-image-with-card-item__text-wrap > h3',
				'.compare__items h3',
			], 'words');

			revealFacts();

			const sections=document.querySelectorAll('section');
			sections.forEach(section=>{
				section.style.opacity=1;
			});
		},150);
	});
})();
